<template>
  <div class="row ios-banner">
    <div class="col col-2 ios-banner__icon">
      <img :src="bannerIcon" alt="Logo">
    </div>
    <div class="col col-9 ios-banner__content">
      <p>
        <span :class="{'text-cf': entity === 'CF', 'text-ccpm': entity === 'CCPM'}">Installer l'application</span>
        sur votre appareil : cliquez sur
        <i class="even-icon-shared" :class="{'text-cf': entity === 'CF', 'text-ccpm': entity === 'CCPM'}" /> puis
        <span :class="{'text-cf': entity === 'CF', 'text-ccpm': entity === 'CCPM'}">Ajouter sur l'écran d'accueil</span>.
      </p>
    </div>
    <div class="col col-1 ios-banner__close">
      <i class="even-icon-close" @click="closeBanner" />
    </div>
  </div>
</template>

<script>
const entity = document
  .querySelector('meta[name="entite"]')
  .getAttribute('content');

export default {
  name: 'IOSInstallBanner',
  data() {
    return {
      entity,
    };
  },
  computed: {
    bannerIcon() {
      let icon = '/pwa-icon/izzy-icons/icon-96x96.png';
      if (this.entity === 'CCPM') {
        icon = '/pwa-icon/ccpm-icons/icon-96x96.png';
      }
      return icon;
    },
  },
  methods: {
    closeBanner() {
      this.$emit('close-banner');
    },
  },
};
</script>

<style lang="scss" scoped>
.ios-banner {
  display: flex;
  background-color: $white;
  padding: 10px 0;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid $menu-font-color;
  height: 70px;
  position: fixed;
  z-index: 5;
  &__icon {
    text-align: center;
    @media (min-width: 768px) {
      padding-top: 5px;
    }
    img {
      width: 32px;
    }
  }
  &__content {
    p {
      line-height: 1.3;
    }
    .text-cf {
      color: $nice-blue;
    }
    .text-ccpm {
      color: $ccpm-font-color;
    }
    .even-icon-shared {
      font-size: 1.3rem;
      padding: 0 3px;
    }
  }
  &__close {
    text-align: center;
    .even-icon-close {
    position: absolute;
    top: 32px;
    margin: 0;
    font-size: 0.7rem;
    color: $main-font-color;
    }
    @media (min-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 15px;
    }
  }
}
</style>
